export enum RecordStatuses {
  active = 1,
  deleted = 2,
  pendingVerification = 3
}
export enum Messages {
  TaskExecuted = "TaskExecuted",
  QueueProcessStarted = "QueueProcessStarted",
  OrderExecuted = "OrderExecuted",
  OrderExecutedLocally = "OrderExecutedLocally",
  InternalServerError = "Internal Server Error",
  KrakenErrorOccurred = "Error Occurred While Posting On Kraken",
  ErrorOccurredExecutingOrder = "Error Occurred While Executing Order",
  OrderExecutedSuccessfully = "Order has been executed successfully",
  BalanceUpdated = "BalanceUpdated"
}
export enum SpinnerSize {
  small = "small",
  default = "default",
  medium = "medium",
  large = "large"
}
export enum InputTypes {
  Text = "text",
  ExpiaryDate = "expiary-date",
  Password = "password",
  TextArea = "textarea",
  Select = "select",
  SelectWithPlaceholder = "select-with-placeholder",
  Number = "number",
  NumberWithSymbol = "number-with-symbol",
  AutoSuggest = "autoSuggest",
  Daterange = "daterange",
  Label = "label",
  NumberWithDropdown = "number-with-dropdown",
  TextInGroup = "text-in-group",
  Date = "date",
  Checkbox = "checkbox",
  TextWithChild = "text-with-child"
}
export enum NotificationTypes {
  success = "success",
  info = "info",
  warning = "warning",
  error = "error"
}
export enum SelectSizes {
  small = "small",
  default = "default",
  large = "large"
}
export enum AccountTypes {
  Individual = "individual",
  Business = "business"
}
export enum NavMenuTypes {
  Sidebar = 1,
  Topbar = 2
}
export enum Genders {
  Male = "male",
  Female = "female",
  Other = "Other"
}

export enum TwoFactorAuthTypes {
  None = "none",
  Google = "google"
}

export enum UserPhoneNumberStatuses {
  Pending = "pending",
  Verified = "verified",
  Deleted = "deleted"
}
